// import { Option } from '../option/option-entity.interface';
// import { Question } from '../question/question-entity.interface';
// import {
//   multiple_option_questionLabel,
//   variable_name,
// } from '../utils/variable-label-utils';

// import { Variable } from '../variable/variable-entity.interface';
import { Element } from '../element/element.interface';

export enum TableCellTypes {
  string = 'string',
  media = 'media',
  codedValue = 'coded-value',
  json = 'json',
}

export enum SchemaType {
  number = 'number',
  integer = 'integer',
  string = 'string',
  boolean = 'boolean',
  array = 'array',
  object = 'object',
  null = 'null',
}
export interface SurveyVariables {
  [key: string]: SurveyVariableDefinition;
}

export enum QuestionVariablePurpose {
  isSkipped = 'isSkipped',
  RESPONSE = 'response',

  OPEN_ENDED = 'open-ended',
  MEDIA_COMMENT = 'media_comment',
  DISPOSITION_CODE = 'dispostion-code',
  PASSIN_FIELD = 'passin-field',

  QUOTA_IS_TERMINATE = 'quota-is-terminate',
  latlng = 'latlng',

  location_name = 'location_name',

  pageTime = 'page-time',
  CONVERSATION = 'conversation',
}

export interface Variable {
  variableListId?: number;

  id?: number;

  variableKey: string;

  variableDisplay: string;

  variable: string;

  question: Element;

  variableCellType: VariableCellTypes;
}

export enum VariableCellTypes {
  string = 'string',
  number = 'number',
  integer = 'integer',

  single_choice = 'single_choice',
  multiple_choice = 'multiple_choice',
}

export const variableCellTypeToSchema = (
  variableCellType: VariableCellTypes,
): SchemaType => {
  switch (variableCellType) {
    case VariableCellTypes.single_choice:
    case VariableCellTypes.multiple_choice:
      return SchemaType.integer;
    default:
      return variableCellType as unknown as SchemaType;
  }
};

export interface SurveyVariableDefinition {
  // The label for this variable
  label: string;
  // The question to which this variable belongs (if its a system variable then it will be null)
  questionId?: string;
  // The question to which this variable belongs
  surveyId?: number;

  // The schema of the variable
  schema: {
    type: SchemaType;
    default: number | string | boolean | [] | object | null | undefined;
    valueLabels?: VariableValuesMap;
  };

  // The purpose code of this variable
  purpose: QuestionVariablePurpose;

  //
  optionAssociation?: {
    mainOptionKey: number;
  };

  variableAssociation?: Variable;

  // How to show in table
  render?: { type: TableCellTypes; conf?: any };
}

export interface VariableValuesMap {
  [key: string]: string | number;
}
